

export const MegawaysFAQ = () => {
    return (
        <>
            <p><strong>Reguli generale</strong></p>
            <span>Înregistrarea la Cursa Megaways este gratuită, însă pentru a participa este necesar un cont activ și validat la Princess Casino. </span>
            <span>Joacă toate sloturile participante. Fiecare pariu de 2 RON îți aduce 2 puncte în cursă, indiferent dacă este câștigător sau nu.</span>
            <span>Te rugăm să consulţi Termenii și Condițiile pentru regulile specifice aplicabile.</span>
            <p><strong>Cum câștig</strong></p>
            <span>Câştigătorii Cursei Megaways sunt stabiliţi pe baza poziţiei unui jucător în Clasament la finalul fiecărei curse.</span>
            <span>În caz de egalitate, jucătorul cu cel mai mare număr de pariuri plasate va fi clasat pe poziţia mai înaltă.</span>
            <span>Pentru a intra în cursă, un jucător trebuie să adune puncte. Fiecare 1 RON pariat îți aduce câte un punct. De exemplu: dacă pariezi 2 RON vei primi 2 puncte indiferent de valoarea castigului.</span>
            <span>Pariul minim pentru CURSA MEGAWAYS este de 2 RON.</span>
            <p><strong>Ce câștig</strong></p>
            <span><strong>Premii în funcție de clasament</strong>: adună cât mai multe puncte și califică-te în topul race-ului pentru un premiu în bani.</span>
            <span><strong>Premii Instant</strong>: acordate zilnic aleatoriu jucătorilor care au acumulat minim 10 puncte în ziua respectivă.</span>
        </>
    )
}